import { useEffect } from 'react';
import { logDebug } from '../utils/logger';

const useSocketListener = (socket, user, eventName, callback, dependencies = []) => {
  useEffect(() => {
    if (user?.companyId && socket && typeof socket.on === 'function') {
      const fullEventName = `company-${user.companyId}-${eventName}`;
      
      logDebug(`Registrando listener: ${fullEventName}`);
      socket.on(fullEventName, callback);

      return () => {
        if (socket && typeof socket.off === 'function') {
          logDebug(`Removendo listener: ${fullEventName}`);
          socket.off(fullEventName, callback);
        }
      };
    }
  }, [socket, user?.companyId, ...dependencies]);
};

export default useSocketListener;
